import { Inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datasetTypeToIcon'
})
export class DatasetTypeToIconPipe implements PipeTransform {
  constructor(@Inject('TypeMappingService') private readonly typeMappingService: any) { }

  transform(type?: string, size?: number): string {
    return this.typeMappingService.mapDatasetTypeToIcon(type, size);
  }
}
